/* eslint-disable quotes */
import { h } from 'vue';
import { vimeo } from '../../vimeo';

const body = `<h4>Fix objects</h4>

<p>Fix or unfix selected objects. With shift pressed it unfixes.</p>

<div style="padding:56.25% 0 0 0;position:relative;">
    <iframe src="${vimeo('556486675')}" loading="lazy"
    style="position:absolute;top:0;left:0;width:100%;height:100%;"
    frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen>
    </iframe>
</div>


<ul class='shortcuts'>
    <li class='shortcuts__item'><b>Shortcuts:</b></li>
    <li class='shortcuts__item'><b>X</b>: Fix objects</li>
    <li class='shortcuts__item'><b>shift-X</b>: Unfix objects</li>
</ul>`;

export default function FixObjectsTooltip() {
    return h('div', { innerHTML: body });
}
